export const config = {
  apiUrl: import.meta.env.VITE_API_URL || 'https://dev-api.cpaitech.com',
  apiVersion: 'v1',
  getApiRoot: () => `${config.apiUrl}/api/${config.apiVersion}`
}; 